// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"83374837","513":"c546e792","787":"d5ebbcf2"}[chunkId] + ".chunk.js";
};